import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var render = function render() {
  var _vm$feedItem$author, _vm$feedItem;
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showMoreTag || _vm.visiblePoiLine ? _c('div', {
    ref: "poiLine",
    staticClass: "title-poi-line"
  }, [_vm.showMoreTag ? _c('div', {
    staticClass: "third-more-tag"
  }, [_c('poiTag', {
    staticClass: "poi-tag-more",
    attrs: {
      "left-icon": (_vm$feedItem$author = _vm.feedItem.author) === null || _vm$feedItem$author === void 0 || (_vm$feedItem$author = _vm$feedItem$author.provider) === null || _vm$feedItem$author === void 0 ? void 0 : _vm$feedItem$author.icon,
      "show-right-icon": true
    },
    on: {
      "poi-click": _vm.poiMoreClick
    }
  }, [_vm._v(_vm._s(((_vm$feedItem = _vm.feedItem) === null || _vm$feedItem === void 0 || (_vm$feedItem = _vm$feedItem.guide) === null || _vm$feedItem === void 0 ? void 0 : _vm$feedItem.message) || '查看更多'))])], 1) : _vm._e(), _vm.visiblePoiLine ? _c('div', {
    ref: "poiLine",
    staticClass: "space-compress",
    class: {
      'poi-line': true
    }
  }, [_vm._l(_vm.poiShowList, function (item, i) {
    return _c('poiTag', {
      key: i,
      ref: 'tag' + i,
      refInFor: true,
      attrs: {
        "poi-item": item,
        "unique_id": _vm.unique_id,
        "left-icon": `https://map-mobile-resource.cdn.bcebos.com/icon/service/feed/default/micro-location${_vm.is_dark ? '-dark' : ''}.png`
      },
      on: {
        "open-Baidu-Map": function ($event) {
          return _vm.$emit('open-Baidu-Map');
        },
        "poi-click": function ($event) {
          return _vm.poiClick(_objectSpread(_objectSpread({}, item), {}, {
            index: _vm.dataIndex
          }));
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.poiString(item)) + " ")]);
  }), _vm.poiNum > 1 && !_vm.isHarmony ? _c('poiTag', {
    ref: "numTag",
    attrs: {
      "show-right-icon": true,
      "unique_id": _vm.unique_id
    },
    on: {
      "poi-click": function ($event) {
        return _vm.poiClick({
          type: 'more-poi'
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.poiNumString) + " ")]) : _vm._e(), _vm.urlParams && _vm.urlParams.chainBrand === '1' && _vm.dataIndex === 0 ? _c('div', {
    ref: "chain",
    staticClass: "chain"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("连锁")])]) : _vm._e()], 2) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };